import { useQuery } from '@tanstack/react-query';

import { getMyApplications } from '@/api/auth/get-my-applications';

import { authKeys } from './query-keys';

/** Open to any signed-in person, so it is safe to ask before the person holds a role. */
export const useMyApplications = (enabled = true) =>
  useQuery({
    queryKey: authKeys.myApplications(),
    queryFn: getMyApplications,
    retry: false,
    enabled,
  });
